<template>
	<svg width="20px" height="9px" viewBox="0 0 20 9" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink">
	    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
	        <g transform="translate(-639.000000, -16.000000)" fill="#B8B8B8">
	            <g>
	                <g transform="translate(639.000000, 16.000000)">
	                    <path d="M16.1036215,0.243583926 C15.9247062,-0.016407097 15.546996,-0.0721194591 15.2686833,0.0950176272 C14.9903705,0.262154713 14.9307321,0.614999673 15.1096474,0.874990696 C15.1295269,0.912132271 15.1692859,0.949273846 15.1891653,0.967844633 L18.4295209,4.47772344 L15.1891653,8.04331462 C14.9506116,8.24759328 14.9307321,8.60043824 15.1692859,8.82328769 C15.3879602,9.04613713 15.7656703,9.06470792 16.0042241,8.84185847 C16.0439831,8.8047169 16.0638625,8.78614611 16.083742,8.74900454 L20,4.45915266 L16.1036215,0.243583926 Z"></path>
	                    <path d="M18.5,4.5 L0.5,4.5" stroke="#B8B8B8" stroke-linecap="round"></path>
	                </g>
	            </g>
	        </g>
	    </g>
	</svg>
</template>
<script>
export default { name: 'navbar-search-arrow-icon' }
</script>
